import React, { Suspense, useContext, useEffect } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Loading from "../components/Loading/Loading";
import Sidebar from "../components/Sidebar";
import ThemedSuspense from "../components/ThemedSuspense";
import { SidebarContext } from "../contexts/SidebarContext";
import routes from "../routes";
import { FixMeLater } from "../types/helpers";
import Main from "./Main";

// TODO after props are put into context
function Layout(props: FixMeLater) {
    const { isSidebarOpen, closeSidebar } = useContext(SidebarContext);
    const location = useLocation();
    const history = useHistory();

    const { totalPaid } = props;

    useEffect(() => {
        if (location.pathname === "/") {
            history.push("/AUTO-KCS");
        }
    }, [location, history]);

    useEffect(() => {
        closeSidebar();
    }, [location, closeSidebar]);

    return (
        <div className={`flex h-screen gradient-dark  ${isSidebarOpen && "overflow-hidden"}`}>
            <Sidebar />
            <div className="flex flex-col flex-1 w-full">
                <Header />
                <Main>
                    {totalPaid !== 0 ? (
                        <Suspense fallback={<ThemedSuspense />}>
                            <Switch>
                                {routes.map((route, i) => {
                                    return route.component ? (
                                        <Route
                                            key={i}
                                            exact={true}
                                            path={`${route.path}`}
                                            render={() => <route.component />}
                                        />
                                    ) : null;
                                })}
                            </Switch>
                        </Suspense>
                    ) : (
                        <div className="w-full h-full flex justify-center">
                            <Loading />
                        </div>
                    )}
                </Main>
            </div>
        </div>
    );
}

export default Layout;
